export default "__VITE_ASSET__wYEzozHd__"